import React from 'react'
import { Container } from "./CMEProfileManagement/ModalContainer";
  
  export default function DeleteSelfReportedActivity(props:any){    
    
   const triggerText = "Delete Activity";  
   const modalHeaderText = "Are you sure?";
   const modalForText = "Delete"; 



  return (
    <Container 
    modalFor={modalForText}
    triggerText={triggerText} 
    modalHeaderText = {modalHeaderText}
    onSubmit={props.onSubmit} 
 
    />
  )
  }